__webpack_require__.p = "https://astrea-dashboard-mfe.aurum.com.br/";